import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  if (!token) {
    return (
      <div className="max-w-md mx-auto py-24 px-6 text-center">
        <p className="overline text-berulia-rosedeep">BERULIA</p>
        <h1 className="font-heading text-4xl mt-3">Lien invalide</h1>
        <p className="mt-6 text-berulia-inkmuted">
          Le lien de réinitialisation est manquant ou incomplet.
        </p>
        <Link to="/mot-de-passe-oublie" className="mt-8 inline-block overline link-underline text-berulia-rosedeep">
          Demander un nouveau lien
        </Link>
      </div>
    );
  }

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    if (password !== confirm) {
      toast.error("Les deux mots de passe ne correspondent pas.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Mot de passe mis à jour ✿");
      navigate("/connexion", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Échec de la réinitialisation. Le lien est peut-être expiré.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto py-24 px-6">
      <p className="overline text-berulia-rosedeep text-center">BERULIA</p>
      <h1 className="font-heading text-4xl text-center mt-3">Nouveau mot de passe</h1>
      <p className="mt-4 text-center text-berulia-inkmuted text-sm">
        Choisissez un mot de passe d'au moins 8 caractères.
      </p>

      <form onSubmit={submit} className="mt-10 space-y-5">
        <label className="block">
          <span className="overline text-berulia-inkmuted">Nouveau mot de passe</span>
          <input
            type="password"
            required
            minLength={8}
            autoComplete="new-password"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="reset-password"
            className="mt-1 w-full bg-white border border-berulia-border px-3 py-2 focus:border-berulia-ink outline-none"
          />
        </label>

        <label className="block">
          <span className="overline text-berulia-inkmuted">Confirmer</span>
          <input
            type="password"
            required
            minLength={8}
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            data-testid="reset-confirm"
            className="mt-1 w-full bg-white border border-berulia-border px-3 py-2 focus:border-berulia-ink outline-none"
          />
        </label>

        <button
          type="submit"
          disabled={loading}
          data-testid="reset-submit"
          className="w-full bg-berulia-rosedeep text-berulia-inkdeep overline py-4 hover:bg-berulia-rose transition disabled:opacity-50"
        >
          {loading ? "Mise à jour…" : "Mettre à jour →"}
        </button>
      </form>
    </div>
  );
}
